import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { StepItem } from 'src/app/models/common/step-item';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { Location } from '@angular/common';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { PageHeader } from 'src/app/models/common/page-header';
import { BaseStepFormComponent } from 'src/app/system-common/base-step-form/base-step-form.component';
import { ContestAndIncentiveDetailsService } from 'src/app/contest-and-incentive-details/services/contest-and-incentive-details.service';
import * as Chart from 'chart.js';

@Component({
  selector: '',
  template: '',
})
export class ShortfallHandler extends BaseStepFormComponent<ContestAndIncentiveDetailsService> implements OnInit {
  public evaluationId;
  public data;
  public rewards: any = {};
  public filteredRewards: any = {};
  rewardTypes: string[] = ['All'];
  selectedType: string = 'Select';
  shortFallChartShow: boolean;
  shortfallErrorMessage: any;
  shortFallChart: Chart;
  chartData: any = [];
  public isModalOpened: Boolean;
  private originalRectangleDraw;
  public currentSelectedTheme;

  constructor(
    service: ContestAndIncentiveDetailsService,
    route: ActivatedRoute,
    router: Router,
    location: Location,
    settingService: SettingService,
    headerService: HeaderService
  ) {
    super(service, route, router, location, settingService, headerService);
    this.shortFallChartShow = false;
    this.isModalOpened = false;
    this.originalRectangleDraw = Chart.elements.Rectangle.prototype.draw;
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.evaluationId = this.route.snapshot.paramMap.get('id');
    this.loadData(this.evaluationId);
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.title = 'Shorfall Details';
    return header;
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'home',
        link: '/home',
      },
      // {
      //   id: 'search',
      //   link: '/search-contest-and-incentive',
      // },
      {
        id: 'Shortfall Details',
      },
    ];
  }

  protected getStepList(): StepItem[] {
    let stepList: StepItem[];
    return stepList;
  }

  protected preLoad() {
    this.loadData(this.evaluationId);
  }

  protected postProcess() {
    this.loadData(this.evaluationId);
  }

  protected loadData(evaluationId: number) {
    this.currentSelectedTheme = this.settingService.getSessionStorageValue('currentSelectedTheme');
    if (
      (this.currentSelectedTheme != undefined || this.currentSelectedTheme != null) &&
      this.currentSelectedTheme.endsWith('.css')
    ) {
      this.currentSelectedTheme = this.currentSelectedTheme.replace('.css', '');
    }

    this.service.getEvaluationDetails(evaluationId).subscribe((data) => {
      this.data = data;
      if (!this.data.success) {
        alert(this.data.message);
        this.location.back();
      }
      const shortfallJson = this.data?.data?.Entity?.shortfalljson;

      if (shortfallJson && this.isJsonString(shortfallJson)) {
        this.rewards = JSON.parse(shortfallJson);
        this.filteredRewards = Object.entries(this.rewards)
          .filter(([_, reward]: [string, any]) => reward.TYPE?.trim() !== 'Over Achieved')
          .reduce((acc, [key, reward]) => {
            acc[key] = reward;
            return acc;
          }, {});
        this.shortFallChartShow = true;
        console.log('this.filteredRewards', this.filteredRewards);

        setTimeout(() => {
          this.barChartBrowser(this.filteredRewards);
        }, 10);

        const typesSet = new Set<string>();

        Object.values(this.rewards).forEach((reward: any) => {
          const type = reward.TYPE?.trim();
          if (type != 'Over Achieved') {
            typesSet.add(type);
          }
        });

        this.rewardTypes = ['Select', 'All', ...Array.from(typesSet)];
      } else {
        this.shortfallErrorMessage = shortfallJson;
      }
    });
  }

  isJsonString(str: string): boolean {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  }

  barChartBrowser(filteredRewards: any) {
    this.shortFallChartShow = true;

    if (this.shortFallChart) {
      this.shortFallChart.destroy();
      this.shortFallChart = null;
    }

    // Custom bar radius drawing
    Chart.elements.Rectangle.prototype.draw = function () {
      const ctx = this._chart.ctx;
      const vm = this._view;
      const radius = 60;
      let left, right, top, bottom;

      if (!vm.horizontal) {
        left = vm.x - vm.width / 2;
        right = vm.x + vm.width / 2;
        top = vm.y;
        bottom = vm.base;
      } else {
        left = vm.base;
        right = vm.x;
        top = vm.y - vm.height / 2;
        bottom = vm.y + vm.height / 2;
      }

      const barWidth = right - left;
      const barHeight = bottom - top;
      const cornerRadius = Math.min(radius, Math.abs(barHeight), Math.abs(barWidth) / 2);

      ctx.beginPath();
      ctx.fillStyle = vm.backgroundColor;
      ctx.strokeStyle = vm.borderColor;
      ctx.lineWidth = vm.borderWidth;

      ctx.moveTo(left, bottom);
      ctx.lineTo(left, top + cornerRadius);
      ctx.quadraticCurveTo(left, top, left + cornerRadius, top);
      ctx.lineTo(right - cornerRadius, top);
      ctx.quadraticCurveTo(right, top, right, top + cornerRadius);
      ctx.lineTo(right, bottom);
      ctx.closePath();
      ctx.fill();

      if (vm.borderWidth) {
        ctx.stroke();
      }
    };

    // === Data Preparation ===
    const ruleIds: string[] = Object.keys(filteredRewards);
    const xAxisLabelMap = new Map<string, string>();
    const criteriaSet = new Set<string>();
    const criteriaShortfallMap = new Map<string, Map<string, number>>();

    ruleIds.forEach((ruleId) => {
      const entry = filteredRewards[ruleId];
      const action = entry?.ACTION?.[0];
      // const actionName = action?.['Action Name'];
      // const actionValue = action?.['Action Value'];

      // if (!actionName || !actionValue) return;

      // const label = `${actionName} - ${actionValue}`;
      let label = '';

      if (action && action['Action Name'] && action['Action Value']) {
        label = `${action['Action Name']} - ${action['Action Value']}`;
      } else {
        const firstCriteria = entry?.TARGETACHIEVEMENT?.[0];
        label = firstCriteria?.['Criteria Name'];
      }
      xAxisLabelMap.set(ruleId, label);

      const targetAchievement = entry?.TARGETACHIEVEMENT ?? [];
      targetAchievement.forEach((crit: any) => {
        const critName = crit['Criteria Name'];
        const achievement = Number(crit['Achievement Percentage'] ?? 0);
        criteriaSet.add(critName);

        if (!criteriaShortfallMap.has(critName)) {
          criteriaShortfallMap.set(critName, new Map<string, number>());
        }

        criteriaShortfallMap.get(critName)!.set(ruleId, achievement);
      });
    });

    const filteredRuleIds = Array.from(xAxisLabelMap.keys());
    const criteriaList = Array.from(criteriaSet);
    const colors = this.service.getColor?.() ?? ['#ff6384', '#36a2eb', '#4bc0c0', '#ffcd56', '#9966ff', '#ff9f40'];

    const datasets = criteriaList.map((crit, idx) => ({
      label: crit,
      data: filteredRuleIds.map((rid) => {
        const val = criteriaShortfallMap.get(crit)?.get(rid);
        return val !== undefined ? Math.min(val, 100) : 0;
      }),
      backgroundColor: colors[idx % colors.length],
      barPercentage: filteredRuleIds.length > 1 ? 0.3 : 0.3,
      categoryPercentage: filteredRuleIds.length > 1 ? 0.4 : 0.2,
    }));

    // === Chart Rendering ===
    setTimeout(() => {
      this.shortFallChart = new Chart('shortfallChart', {
        type: 'bar',
        data: {
          labels: filteredRuleIds.map((rid) => xAxisLabelMap.get(rid)!),
          datasets,
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  max: 100,
                  fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
                  fontFamily: 'montserratregular',
                },
                gridLines: {
                  color: this.currentSelectedTheme === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.1)',
                  zeroLineColor: this.currentSelectedTheme === 'dark' ? '#fff' : 'rgba(10, 10, 10, 0.2)',
                  borderColor: this.currentSelectedTheme === 'dark' ? '#fff' : '#000',
                  drawBorder: true,
                  lineWidth: 1,
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Achievement Percentage',
                  fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
                  fontFamily: 'montserratregular',
                },
              },
            ],
            xAxes: [
              {
                ticks: {
                  autoSkip: false,
                  fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
                  fontFamily: 'montserratregular',
                },
                gridLines: {
                  color: this.currentSelectedTheme === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.1)',
                  zeroLineColor: this.currentSelectedTheme === 'dark' ? '#fff' : 'rgba(10, 10, 10, 0.2)',
                  borderColor: this.currentSelectedTheme === 'dark' ? '#fff' : '#000',
                  drawBorder: true,
                  lineWidth: 1,
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Actions',
                  fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
                  fontFamily: 'montserratregular',
                },
              },
            ],
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
              fontFamily: 'montserratregular',
            },
          },
          title: {
            display: true,
            text: 'Achievement Percentage by Action',
            fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
            fontFamily: 'montserratregular',
          },
          tooltips: {
            bodyFontFamily: 'montserratregular',
          },
          plugins: {
            datalabels: false,
          },
        },
      });
    }, 10);
  }

  filterByType() {
    const filtered: any = {};

    Object.entries(this.rewards).forEach(([key, reward]: [string, any]) => {
      const rewardType = reward.TYPE?.trim();

      if (rewardType === 'Over Achieved') {
        return;
      }

      if (this.selectedType === 'All' || this.selectedType === 'Select' || rewardType === this.selectedType) {
        filtered[key] = reward;
      }
    });

    this.filteredRewards = filtered;
    this.shortFallChartShow = false;

    setTimeout(() => {
      if (this.shortFallChart) {
        this.shortFallChart.destroy();
        this.shortFallChart = null;
      }
      this.shortFallChartShow = true;

      setTimeout(() => {
        this.barChartBrowser(this.filteredRewards);
        this.closeModal();
      }, 10);
    }, 10);
  }

  onDetailsBtnClick() {
    this.router.navigate(['/contest-and-incentive-details-drilldown', this.evaluationId]);
  }

  onFilterData() {
    this.isModalOpened = true;
    $('#shortFallModal').toggle();
  }

  closeModal() {
    this.isModalOpened = false;
    $('#shortFallModal').hide();
  }

  isValidType(type: string): boolean {
    return type && type !== 'Select';
  }
  goBack(): void {
    this.location.back();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    Chart.elements.Rectangle.prototype.draw = this.originalRectangleDraw;
  }
}
